<template>
    <rkm-area
        title="Histórico do Paciente ConectaSUS - Cidadão"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-checkbox v-model="data.model.exibeDetalhesAtendimento">
                    Exibir detalhes do atendimento
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Quando ativado, o App do Cidadão passa a receber os detalhes assistenciais do atendimento conforme os grupos selecionados abaixo. Quando desativado, o Histórico de Atendimento exibe somente os dados principais da consulta (profissional, data, horários, especialidade, receitas, solicitações e status).'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.model.exibeDetalhesAtendimento">
            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.exibeSubjetivo">
                    Subjetivo
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Motivo do atendimento, queixas e descrição do subjetivo.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.exibeObjetivo">
                    Objetivo
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Antropometria, sinais vitais, glicemia capilar, resultados de exames e demais dados objetivos do atendimento.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.exibeAvaliacao">
                    Avaliação
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Problemas e condições avaliadas, rastreamentos e doenças transmissíveis.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.exibePlano">
                    Plano
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Prescrições, solicitações de exames, encaminhamentos, atestados e orientações.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.exibeFinalizacao">
                    Finalização
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Desfecho, conduta, tipo de atendimento e equipe responsável.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-checkbox v-model="data.model.exibeProcedimentos">
                    Procedimentos
                    <rkm-icon
                        icon="info"
                        color="secondary"
                        class="infor"
                        small
                        v-rkm-popover.hover.right="{
                            html: true,
                            content: 'Procedimentos registrados no atendimento. O App do Cidadão recebe apenas a descrição do procedimento, nunca o código SIGTAP.'
                        }"
                    />
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
const GRUPOS = [
    'exibeSubjetivo',
    'exibeObjetivo',
    'exibeAvaliacao',
    'exibePlano',
    'exibeFinalizacao',
    'exibeProcedimentos',
]

export default {
    props: {
        data: {required: true, type: Object},
    },
    watch: {
        'data.model.exibeDetalhesAtendimento'(exibeDetalhes) {
            if (exibeDetalhes === false) return

            if (GRUPOS.some(grupo => this.data.model[grupo])) return

            GRUPOS.forEach(grupo => {
                this.data.model[grupo] = true
            })
        },
    },
}
</script>
<style scoped>
    .infor {
        color: #acacac;
        height: 15px;
        width: 15px !important;
        border-radius: 31px;
        padding: 3px;
        border: 1px solid #c2c2c2;
        vertical-align: middle;
        margin-left: 4px;
    }
</style>
